import logo from './logo.svg';
import './App.css';
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import Indexs from './Indexs.js';
//import { AuthProvider } from './contexts/AuthContext';
import Auth2 from './Auth2.js';
import { ConvexProvider } from "convex/react";
import { client } from "./convexClient";
import MFASetup from './MFASETUP2.js';
import MFAVerify from './MFAVerify.js';
import ScriptGenerator2 from './ScriptGenerator3.js';
import PricingPage from './PricingPage.js';
import ProtectedRoute from './ProtectedRoute';

//import 
function App() {

  return (
    <div>
      <ConvexProvider client={client}>
    <Router>
        <Routes>
        <Route path="/" element={<Indexs />} />
        <Route path="/auth" element={<Auth2 />} />
        <Route path="/mfa-setup" element={<MFASetup />} />
        <Route path="/mfa-verify" element={<MFAVerify />} />
        <Route path="/dashboard" element={
            <ProtectedRoute>
              <ScriptGenerator2 />
            </ProtectedRoute>
          } />
        <Route path="/pricingpage" element={<PricingPage />} />      
        </Routes>
    </Router>
    </ConvexProvider>
  </div>
  );
}

export default App;
